var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { Demographics } from '../../../classes/demographics';
import { EventEmitter } from 'events';
import { SCREEN_SIZE } from '../../../classes/enums';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { CHART_SCRIPT } from '../../../classes/dynamicScripts';
import { truncate } from 'lodash';
import { CommunicationService } from '../../../services/communication.service';
import { HasSubscriptions } from "../../has-subscriptions";
import { Neighbourhood } from "../../../classes/neighbourhood";
var DemographicsSectionComponent = /** @class */ (function (_super) {
    __extends(DemographicsSectionComponent, _super);
    function DemographicsSectionComponent(domManipulationService, communicationService) {
        var _this = _super.call(this) || this;
        _this.domManipulationService = domManipulationService;
        _this.communicationService = communicationService;
        _this.ready = new EventEmitter();
        _this.SCREEN_SIZE = SCREEN_SIZE;
        return _this;
    }
    DemographicsSectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) {
            _this.screenSize = screenSize;
        }));
    };
    DemographicsSectionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.tenancyChartSubs = this.domManipulationService.loadScript(CHART_SCRIPT).subscribe(function () {
            _this.hasChartJsLoaded = true;
        });
    };
    DemographicsSectionComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.tenancyChartSubs) {
            this.tenancyChartSubs.unsubscribe();
        }
    };
    /*
    Reduce length of text to 'length' number of characters and append '...' at the end
     */
    DemographicsSectionComponent.prototype.reduceText = function (text, length) {
        return truncate(text, {
            'length': length,
            'separator': ' '
        });
    };
    return DemographicsSectionComponent;
}(HasSubscriptions));
export { DemographicsSectionComponent };
